import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import CapabilitiesOverview from "../pages/capabilities/page";
import InfrastructureNetwork from "../pages/capabilities/infrastructure/page";
import DatabaseDataPlatform from "../pages/capabilities/database/page";
import ApplicationPlatform from "../pages/capabilities/application/page";
import MicrosoftSolutions from "../pages/capabilities/microsoft/page";
import WebDigitalSolutions from "../pages/capabilities/web/page";
import MobileAppDevelopment from "../pages/capabilities/mobile/page";
import AIEngineering from "../pages/capabilities/ai/page";
import CloudServices from "../pages/capabilities/cloud/page";
import ExperienceOverview from "../pages/experience/page";
import UsaGovernmentExperience from "../pages/experience/usa-government/page";
import InternationalExperience from "../pages/experience/international/page";
import CommercialExperience from "../pages/experience/commercial/page";
import Markets from "../pages/markets/page";
import About from "../pages/about/page";
import Careers from "../pages/about/careers/page";
import Resources from "../pages/resources/page";
import CapabilityStatement from "../pages/resources/capability-statement/page";
import ContractingInformation from "../pages/resources/contracting-information/page";
import Insights from "../pages/resources/insights/page";
import InsightArticle from "../pages/resources/insights/insight-page";
import Contact from "../pages/contact/page";
import ProjectTypes from "../pages/resources/project-types/page";
import Technologies from "../pages/technologies/page";
import PrivacyPolicy from "../pages/legal/privacy-policy/page";
import TermsWebsiteNotice from "../pages/legal/terms-website-notice/page";
import AccessibilityStatement from "../pages/legal/accessibility-statement/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/capabilities", element: <CapabilitiesOverview /> },
  { path: "/capabilities/infrastructure-network-engineering", element: <InfrastructureNetwork /> },
  { path: "/capabilities/database-data-platform", element: <DatabaseDataPlatform /> },
  { path: "/capabilities/application-platform-engineering", element: <ApplicationPlatform /> },
  { path: "/capabilities/microsoft-solutions", element: <MicrosoftSolutions /> },
  { path: "/capabilities/web-digital-solutions", element: <WebDigitalSolutions /> },
  { path: "/capabilities/mobile-application-development", element: <MobileAppDevelopment /> },
  { path: "/capabilities/ai-intelligent-engineering", element: <AIEngineering /> },
  { path: "/capabilities/cloud-services", element: <CloudServices /> },
  { path: "/experience", element: <ExperienceOverview /> },
  { path: "/experience/usa-government", element: <UsaGovernmentExperience /> },
  { path: "/experience/international", element: <InternationalExperience /> },
  { path: "/experience/commercial", element: <CommercialExperience /> },
  { path: "/markets", element: <Markets /> },
  { path: "/about", element: <About /> },
  { path: "/about/careers", element: <Careers /> },
  { path: "/resources", element: <Resources /> },
  { path: "/resources/capability-statement", element: <CapabilityStatement /> },
  { path: "/resources/contracting-information", element: <ContractingInformation /> },
  { path: "/resources/insights", element: <Insights /> },
  { path: "/resources/insights/:slug", element: <InsightArticle /> },
  { path: "/resources/project-types", element: <ProjectTypes /> },
  { path: "/technologies", element: <Technologies /> },
  { path: "/privacy-policy", element: <PrivacyPolicy /> },
  { path: "/terms-website-notice", element: <TermsWebsiteNotice /> },
  { path: "/accessibility-statement", element: <AccessibilityStatement /> },
  { path: "/contact", element: <Contact /> },
  { path: "*", element: <NotFound /> },
];

export default routes;